import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
} from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunks";

import logoLight from "../../assets/images/logo-light.png";
import { createSelector } from "reselect";
//import images
import BNRathiLogo from "../../assets/images/BNRathiLogo.png";
import { showToast } from "../../Components/ToastNotification";
import LoginPageLogo from "../../Components/Common/LoginPageLogo";

const Login = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectLayoutState = (state) => state;
  const loginpageData = createSelector(selectLayoutState, (state) => ({
    user: state.Account.user,
    error: state.Login.error,
    loading: state.Login.loading,
    errorMsg: state.Login.errorMsg,
  }));
  // Inside your component
  const { user, error, loading, errorMsg } = useSelector(loginpageData);

  const [userLogin, setUserLogin] = useState([]);
  const [passwordShow, setPasswordShow] = useState(false);

  useEffect(() => {
    if (user && user) {
      const updatedUserData =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? user.multiFactor.user.client_code
          : user.user.client_code;
      const updatedUserPassword =
        process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? ""
          : user.user.confirm_password;
      setUserLogin({
        client_code: updatedUserData,
        password: updatedUserPassword,
      });
    }
  }, [user]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      client_code:  "",
      password:  "",
      // phone: "9116443006",
    },
    validationSchema: Yup.object({
      client_code: Yup.string().required("Please enter your client code"),
      password: Yup.string().required("Please enter your password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate))
        .then((res) => {
          // console.log("res",res)
          if (res?.code === 200) {
            showToast(res.message, "success");

            navigate("/verify-phone", { state: res.data });
          } else {
            showToast(res.message, "error");
          }
        })
        .catch((err) => {
          showToast(err, "error");
          // console.log("err", err);
        });
    },
  });

  const signIn = (type) => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  //handleTwitterLoginResponse
  // const twitterResponse = e => {}

  //for facebook and google authentication
  const socialResponse = (type) => {
    signIn(type);
  };

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetLoginFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);


  useEffect(() => {
    // Check if auto logout flag is set
    if (localStorage.getItem("autoLogout") === "true") {
      showToast("Session expired. Please login again.", "error");


      // Remove the flag so the toast doesn't show again on refresh
      localStorage.removeItem("autoLogout");
    }
  }, []);

  document.title = "";
  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <Container>
            <Row className="justify-content-center">
              <Col md={12} lg={10} xl={10} className="">
                <Card className="mt-4 mb-0">
                  <CardBody className="p-0">
                    <Row className="m-0 p-0">
                      <LoginPageLogo />
                      <Col xxl={6} xl={6} lg={6} md={6} sm={12} className="p-0">
                        <div className="p-4">
                          <div className="text-center mt-2">
                            <h3 className="text-dark mb-1">
                              Welcome to B.N.Rathi
                            </h3>
                            <p className="text-muted fs-p-sm">
                              Sign in to continue
                            </p>
                          </div>
                          {error && error ? (
                            <Alert color="danger"> {error} </Alert>
                          ) : null}
                          <div className="p-2 mt-4">
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                validation.handleSubmit();
                                return false;
                              }}
                              action="#"
                            >
                              <div className="mb-3">
                                <Label htmlFor="client_code" className="form-label">
                                  Client Code
                                </Label>
                                <Input
                                  name="client_code"
                                  className="form-control"
                                  placeholder="Enter client code"
                                  type="text"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.client_code || ""}
                                  invalid={
                                    validation.touched.client_code &&
                                    validation.errors.client_code
                                      ? true
                                      : false
                                  }
                                />
                                {validation.touched.client_code &&
                                validation.errors.client_code ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.client_code}
                                  </FormFeedback>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <div className="float-end">
                                  <Link
                                    to="/forgot-password"
                                    className="text-muted"
                                  >
                                    Forgot password?
                                  </Link>
                                </div>
                                <Label
                                  className="form-label"
                                  htmlFor="password-input"
                                >
                                  Password
                                </Label>
                                <div className="position-relative auth-pass-inputgroup mb-3">
                                  <Input
                                    name="password"
                                    value={validation.values.password || ""}
                                    type={passwordShow ? "text" : "password"}
                                    className="form-control pe-5"
                                    placeholder="Enter Password"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                      validation.touched.password &&
                                      validation.errors.password
                                        ? true
                                        : false
                                    }
                                  />
                                  {validation.touched.password &&
                                  validation.errors.password ? (
                                    <FormFeedback type="invalid">
                                      {validation.errors.password}
                                    </FormFeedback>
                                  ) : null}
                                  <button
                                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                    onClick={() =>
                                      setPasswordShow(!passwordShow)
                                    }
                                    type="button"
                                    id="password-addon"
                                  >
                                    <i className="ri-eye-fill align-middle"
                                    style={
                                      validation.touched.password && validation.errors.password
                                        ? { paddingRight: "1.2rem" }
                                        : {}
                                    }
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              <div className="form-check">
                                <Input
                                  className="form-check-input"
                                  type="checkbox"
                                  value=""
                                  id="auth-remember-check"
                                />
                                <Label
                                  className="form-check-label"
                                  htmlFor="auth-remember-check"
                                >
                                  Remember me
                                </Label>
                              </div>

                              <div className="mt-4">
                                <Button
                                  color="primary"
                                  disabled={
                                     loading 
                                  }
                                  className="btn btn-primary w-100"
                                  type="submit"
                                >
                                  {loading ? (
                                    <Spinner size="sm" className="me-2">
                                      {" "}
                                      Loading...{" "}
                                    </Spinner>
                                  ) : null}
                                  Sign In
                                </Button>
                              </div>
                            </Form>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>

                <div className="mt-4 text-center">
                  <p className="mb-2 text-white">
                    Don't have an account ?{" "}
                    <Link
                      to="https://ekyc.bnrsecurities.com/invite?rc=KE87F3"
                      target="_blank"
                      className="fw-semibold text-white text-decoration-underline"
                    >
                      {" "}
                      Signup{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default withRouter(Login);
